import { render, staticRenderFns } from "./DetailAnaliticStudent.vue?vue&type=template&id=7c9bbf80&scoped=true"
import script from "./DetailAnaliticStudent.vue?vue&type=script&lang=js"
export * from "./DetailAnaliticStudent.vue?vue&type=script&lang=js"
import style0 from "./DetailAnaliticStudent.vue?vue&type=style&index=0&id=7c9bbf80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9bbf80",
  null
  
)

export default component.exports